import { useClientRest } from "@shared/hooks";
import { toSnake, transformQueryParamsWithoutLocale } from "@shared/utils";
import { useQuery } from "@tanstack/react-query";

export type Industry = {
  id: string;
  name: string;
};

export function useIndustries({
  keyword,
  page = 1,
  limit = 10,
  enabled = true,
}: {
  keyword: string;
  page?: number;
  limit?: number;
  enabled?: boolean;
}) {
  const { request } = useClientRest();

  const query = useQuery<{ data: Industry[] }>({
    queryKey: ["common-industries-", keyword, limit, page],
    queryFn: () =>
      request({
        url: transformQueryParamsWithoutLocale("/karirhub/onboarding/v2/industries", toSnake({
          keyword,
          limit,
          page,
        })),
        method: "GET",
        options: {
          cache: "no-store",
        },
      }),
    enabled: enabled,
  });

  const refetch = () => {
    query.refetch();
  };

  return {
    isLoading: query.isLoading,
    industries: query.data?.data || [],
    query,
    refetch,
  };
}
